import Vue from 'vue'
import Amplify, * as AmplifyModules from 'aws-amplify'
import { AmplifyPlugin } from 'aws-amplify-vue'

Amplify.configure({ ssr: true, aws_project_region: 'eu-west-1' })

Vue.use(AmplifyPlugin, AmplifyModules)

